import { ReactElement, useEffect, useRef } from 'react';
import { ThermalComfortHistoryInfo } from '../../types';
import { GraphInnerContainer, LegendContainer } from '~/pages/NewOverview/components/History/styles';
import { ThermalComfortVariant } from '../UnitsInfo/types';
import { Legend } from 'pages/NewOverview/components/History/Legend';
import { colors } from 'styles/colors';
import { colorByThermalComfortVariant, parseThermalComfortVariantLabel } from '../../helpers';
import { useTranslation } from 'react-i18next';
import { useGenerateThermalComfortGraph } from '../../hooks/useGenerateThermalComfortGraph';

interface ThermalComfortGraphProps {
  data: ThermalComfortHistoryInfo | undefined;
}

export function ThermalComfortGraph({
  data,
}: Readonly<ThermalComfortGraphProps>): ReactElement {
  const chartReference = useRef<HTMLDivElement>(null);

  const { renderThermalComfortChart } = useGenerateThermalComfortGraph(chartReference, !data);

  useEffect(() => renderThermalComfortChart(data), [data]);

  return (
    <>
      <GraphInnerContainer containerId="thermal-comfort-card">
        <div
          id="thermal-comfort-card"
          ref={chartReference}
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </GraphInnerContainer>
      <LegendGraph disabled={!data} />
    </>
  );
}

function LegendGraph({
  disabled,
}: Readonly<{ disabled: boolean }>): ReactElement {
  return (
    <LegendContainer>
      {disabled ? (
        <ThermalComfortLegend variant="no-data" />
      ) : (
        <>
          <ThermalComfortLegend variant="comfortable" />
          <ThermalComfortLegend variant="belowLimit" />
          <ThermalComfortLegend variant="aboveLimit" />
          <ThermalComfortLegend variant="inoperative" />
        </>
      )}
    </LegendContainer>
  );
}

function ThermalComfortLegend({
  variant,
}: Readonly<{ variant: ThermalComfortVariant | 'no-data' }>): ReactElement {
  const { t } = useTranslation();

  if (variant === 'no-data') {
    return (
      <Legend
        color={colors.icon['disabled-300']}
        label={t('semDados')}
      />
    );
  }

  return (
    <Legend
      color={colorByThermalComfortVariant(variant)}
      label={parseThermalComfortVariantLabel(variant)}
    />
  );
}
